import BaseAction from './BaseAction.js';
import {initializeEffect} from 'components/effects/constants.js';
import {getMidiEffect} from 'effects/midi/getMidiEffect.js';

class BaseEffectAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({effect, track, group, send}) {}

    undo(action) {
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        let {payload} = operation;
        if (payload.group !== undefined) {
            payload.group = payload.group.groupNumber;
        }
        if (operation.send !== undefined) {
            payload.send = payload.send.sendNumber;
        }
        payload.isMidiEffect = payload.effect.isMidiEffect();
        payload.effect = payload.effectJson;
        return json;
    }

    deserialize(json) {
        let action = super.deserialize(json);
        let {payload} = action;
        let element = payload.track || payload.group || payload.send;
        let effect;
        if (payload.isMidiEffect) {
            effect =
                element.midiEffects.getEffectById(payload.effect.id);
            if (effect === undefined) {
                effect = getMidiEffect(payload.effect, element);
                effect.fromJson(payload.effect);
            }
        } else {
            effect =
                element.effectsChain.getEffectById(payload.effect.id);
            if (effect === undefined) {
                effect = initializeEffect(payload.effect.name, this.sequencerEngine);
                effect.fromJson(payload.effect, this.sequencerEngine.tracks, payload.track.trackNumber);
            }
        }
        payload.effect = effect;
        return action;
    }
}

export default BaseEffectAction;
